import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/services/core/shared.service';
import { IAttachedReportAnalyteViewModel, IAttachedReportViewModel, ICertificateReportMatrixViewModel, ICertificateReportViewModel, IFoaReportViewModel } from 'app/models/report/reports';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { CertificateService } from 'app/services/lab-user-menu/certificate.service';
import { CertificateReportComponent } from '../certificateReport/certificateReport.component';

@Component({
  selector: 'attachedReport',
  templateUrl: './attachedReport.component.html',
  styleUrls: ['./attachedReport.component.scss']
})

export class AttachedReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;
  public attachedData: IAttachedReportViewModel = {} as IAttachedReportViewModel;
  public analyteData: IAttachedReportAnalyteViewModel[] = [];
  public uniqueAnalyteNames: string[] = [];
  public certId: number = 0;
  public attachedList: { matrix: string, foaList: { methodReference: string, foas: IAttachedReportAnalyteViewModel[] }[] }[] = [];
  private file: File = null;
  public datePrinted: string = new Date().toLocaleDateString('en-US');
  // public groupedTechnologies: { matrix: string, foaList: { method: string, foas: IAttachedReportAnalyteViewModel[] }[] }[] = [];

  constructor(public searchLabsService: SearchLabsService,  
    public settings: SettingsService,
    private dialogRef: MatDialogRef<AttachedReportComponent>,
    private sharedService: SharedService,
    private certificateService: CertificateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log('attached report for application', this.sharedService.currentApplication,
      this.data);
    this.attachedData = this.data.attachedData;
    this.analyteData = this.attachedData.attachedData||[];
    this.certId = this.data.certId;
    // this.analyteData = this.data.attachedData.analytes || [];
    this.groupAnalytes(this.analyteData);
  }

  groupAnalytes(technologies: IAttachedReportAnalyteViewModel[]): void {
    // First group by name
    const byMatrix: { [key: string]: IAttachedReportAnalyteViewModel[] } = {};
    technologies.forEach(tech => {
      if (!byMatrix[tech.matrix]) {
        byMatrix[tech.matrix] = [];
      }
      byMatrix[tech.matrix].push(tech);
    });

    // Then group each name by instrumentTechnology
    this.attachedList = Object.keys(byMatrix).map(matrix => {
      const methodsForMatrix = byMatrix[matrix];
      const byMethods: { [key: string]: IAttachedReportAnalyteViewModel[] } = {};
      
      methodsForMatrix.forEach(analyte => {
        if (!byMethods[analyte.methodReference]) {
          byMethods[analyte.methodReference] = [];
        }
        byMethods[analyte.methodReference].push(analyte);
      });

      return {
        matrix: matrix,
        foaList: Object.keys(byMethods).map(ref => ({
          methodReference: ref,
          foas: byMethods[ref]
        }))
      };
    });
    console.log('grouped analytes', this.attachedList);
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Certificate_Report.pdf');
      this.savePdfToDatabase();
    }
  }

  savePdfToDatabase(): void {
    const element = document.querySelector('.report-content');
    if (!element) {
      console.error('PDF content element not found');
      return;
    }

    this.pdf.export().then((group) => {
      return exportPDF(group);
    }).then((dataUri) => {
      // Convert data URI to Blob
      const byteString = atob(dataUri.split(',')[1]);
      const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });
      const fileName: string = `ORELAP_Certificate_Report.pdf`;

      // this.downloadFile(`ORELAP_Attached_ReportXXX.pdf`, blob);
      const formData = new FormData();
      // Save to database
      
      formData.append('file', blob, fileName);
      this.certificateService.savePrintedAttached(
        this.certId,
        formData
      ).subscribe(
        response => {
          alert('PDF saved to database successfully');
        },
        error => {
          alert('Error saving PDF to database: ' + error.message);
        }
      );
    }).catch((error) => {
      alert('Error generating PDF ' + error.message);
    });
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }
  
  closeDialog(): void {
    this.dialogRef.close();
  }
  
  // Helper method to normalize special characters for PDF (replaces accented chars with ASCII equivalents)
  encodeForPdf(text: string): string {
    if (!text) return '';
    return text
      .replace(/[éèêë]/g, 'e')
      .replace(/[ÉÈÊË]/g, 'E')
      .replace(/[àâä]/g, 'a')
      .replace(/[ÀÂÄ]/g, 'A')
      .replace(/[ùûü]/g, 'u')
      .replace(/[ÙÛÜ]/g, 'U')
      .replace(/[îï]/g, 'i')
      .replace(/[ÎÏ]/g, 'I')
      .replace(/[ôö]/g, 'o')
      .replace(/[ÔÖ]/g, 'O')
      .replace(/[ç]/g, 'c')
      .replace(/[Ç]/g, 'C')
      .replace(/[ñ]/g, 'n')
      .replace(/[Ñ]/g, 'N');
  }
}
